
import React from 'react';
import content from '../data/content';
import '../styles/Join.css';

function Join() {
  const { joinUs } = content;

  return (
    <section id="join" className="join-section">
      <div className="join-container">
        <h2>{joinUs.title}</h2>
        <div className="join-content">
          <p className="join-description">{joinUs.description}</p>
          <p className="join-how-to">{joinUs.howToJoin}</p>
          <ul className="join-links">
            <li>
              <a href={joinUs.links[0].url} target="_blank" rel="noopener noreferrer" className="icon-link">
                <img src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" alt="LINE友だち追加" className="social-icon" />
              </a>
            </li>
            <li>
              <a href={joinUs.links[1].url} target="_blank" rel="noopener noreferrer" className="icon-link">
                <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube" className="social-icon youtube-icon" />
              </a>
            </li>
            <li><a href={`mailto:${joinUs.contactEmail}`}>{joinUs.contactEmail}</a></li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Join;
